import { render, staticRenderFns } from "./ruku_show.vue?vue&type=template&id=635aceb8&scoped=true"
import script from "./ruku_show.vue?vue&type=script&lang=js"
export * from "./ruku_show.vue?vue&type=script&lang=js"
import style0 from "./ruku_show.vue?vue&type=style&index=0&id=635aceb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635aceb8",
  null
  
)

export default component.exports